import { VerifyPassword, validateEmail } from "./accountChecks";

// Returns true if valid, or/and calls the callback function
export function ValidateAccountCallback(
    setEmailErrorMessage: (val: string) => void,
    setPasswordErrorMessage: (val: string) => void,
    setVerifyPasswordErrorMessage: (val: string) => void,
    email: string,
    password: string,
    confirmPassword: string,
    callbackIfValid?: ()=> void
) {
    setEmailErrorMessage(undefined);
    setPasswordErrorMessage(undefined);
    setVerifyPasswordErrorMessage(undefined);

    // Check email is valid
    if (!validateEmail(email)) {
        setEmailErrorMessage("Enter a valid email address");
        return false;
    }
    
    // Returns null if password is valid
    const verifyPassword = VerifyPassword(password);
    if (verifyPassword !== null) {
        setPasswordErrorMessage(verifyPassword);
        return false; // Stop function if password is not valid
    }
    
    if (password !== confirmPassword) {
        setVerifyPasswordErrorMessage("Passwords do not match.");
        return false;
    }

    if(callbackIfValid){
        callbackIfValid();
    }
    return true;
}
